import React, { useState } from "react";
import "./styles.css";
import { WebcamMirror } from "./components/webcamMirror/WebcamMirror";
import { useKeyPress } from "./hooks/useKeyPress";
import Controls, { defaultSettings } from "./components/controls/Controls";
// import { useInterval } from "./hooks/useInternval";
import { useLocalStorage } from "./hooks/useLocalStorage";

export default function App() {
  const [showControls, setShowControls] = useState(false);
  const [settings, setSettings] = useLocalStorage(
    "lastHumanSettings",
    defaultSettings
  );
  // const [currHue, setCurrHue] = useState(0);

  useKeyPress("h", () => setShowControls((prev) => !prev));

  // useInterval(() => {
  //   if (settings.cycleColours) {
  //     let newHue = currHue + 1;
  //     if (newHue > 360) newHue = 0;

  //     setCurrHue(newHue);
  //     const newBlockColour = `hsl(${newHue}, 100%, 70%)`;
  //     setSettings({ ...settings, blockColour: newBlockColour });
  //   }
  // }, 20);

  return (
    <div>
      {showControls && (
        <Controls settings={settings} setSettings={setSettings} />
      )}

      <WebcamMirror showVideo={false} settings={settings} />
    </div>
  );
}
